/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FcbFormateurMetierAgrementLiesDto
 */
export interface FcbFormateurMetierAgrementLiesDto {
    /**
     * 
     * @type {number}
     * @memberof FcbFormateurMetierAgrementLiesDto
     */
    idFormateurAgrement?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof FcbFormateurMetierAgrementLiesDto
     */
    idsMetier?: Array<number> | null;
}

/**
 * Check if a given object implements the FcbFormateurMetierAgrementLiesDto interface.
 */
export function instanceOfFcbFormateurMetierAgrementLiesDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbFormateurMetierAgrementLiesDtoFromJSON(json: any): FcbFormateurMetierAgrementLiesDto {
    return FcbFormateurMetierAgrementLiesDtoFromJSONTyped(json, false);
}

export function FcbFormateurMetierAgrementLiesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbFormateurMetierAgrementLiesDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idFormateurAgrement': !exists(json, 'idFormateurAgrement') ? undefined : json['idFormateurAgrement'],
        'idsMetier': !exists(json, 'idsMetier') ? undefined : json['idsMetier'],
    };
}

export function FcbFormateurMetierAgrementLiesDtoToJSON(value?: FcbFormateurMetierAgrementLiesDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idFormateurAgrement': value.idFormateurAgrement,
        'idsMetier': value.idsMetier,
    };
}

